import { Button, Select, SelectItem, Tooltip } from '@panwds/react-ui'
import type { VFC } from 'react'
import type { IAM_IDP } from '../../../../../common/reducers/types/IAMReducer.types'
import { LABEL_INACTIVE_IDP } from '../../../../constants/LabelConstants'

type DropdownItem = {
  action?: Function
} & SelectItem

const ActionsDropdown: VFC<{
  idp?: IAM_IDP,
  isLoading?: boolean,
  actions: DropdownItem[]
}> = ({ isLoading, actions, idp }) => {

  return (
    <>
      {!idp || idp?.isEditable ? (
        <Select
          addClassName='cmm-modal-select'
          fitToItemWidth
          disabled={isLoading}
          button={(
            <Button
              disabled={isLoading}
              isMenu
            >Actions</Button>
          )}
          items={actions}
          onChange={change => {
            const clickAction = actions.find((o: any) => o?.value === change.selectedItem.value)?.action
            clickAction && clickAction()
          }}
        />
      ) : (
        <Tooltip label={LABEL_INACTIVE_IDP}>
          <div>
            <Select
              addClassName='cmm-modal-select'
              fitToItemWidth
              disabled={true}
              button={(
                <Button
                  disabled={true}
                  isMenu
                >Actions</Button>
              )}
              items={actions}
              onChange={change => {
                const clickAction = actions.find((o: any) => o?.value === change.selectedItem.value)?.action
                clickAction && clickAction()
              }}
            />
          </div>
        </Tooltip>
      )}
    </>
  )
}
export default ActionsDropdown
